import { render, staticRenderFns } from "./PositionsHero.vue?vue&type=template&id=18212d68&scoped=true"
import script from "./PositionsHero.js?vue&type=script&lang=js&external"
export * from "./PositionsHero.js?vue&type=script&lang=js&external"
import style0 from "./PositionsHero.scss?vue&type=style&index=0&id=18212d68&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18212d68",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotPositionsSearch: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/PositionsSearch/PositionsSearch.vue').default,HotHomePositionsList: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Organisms/HomePositionsList/HomePositionsList.vue').default,HotContainer: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Container/Container.vue').default})
